/*
 * `CaseHeader` (rendered beside the case outlet) owns the case's one
 * `useCaseDetails` instance; it publishes the result here so the IDE explorer
 * header reads and edits the same state instead of fetching it again.
 */
import { useSyncExternalStore } from "react";

import type { CaseDetails } from "./useCaseDetails";

let current: CaseDetails | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const publishCaseDetails = (details: CaseDetails | null) => {
  if (current === details) return;
  current = details;
  listeners.forEach((l) => l());
};

/** The published details for `individualId`, or null while none match. */
export const useSharedCaseDetails = (
  individualId: string
): CaseDetails | null => {
  const details = useSyncExternalStore(
    subscribe,
    () => current,
    () => null
  );
  return details && details.individualId === individualId ? details : null;
};
